import "core-js/stable";
import "regenerator-runtime/runtime";

import * as React from "react";
import * as ReactDOM from "react-dom";

import { MappingWorkbench } from "@mapping/components/MappingWorkbench";

ReactDOM.render(
  <MappingWorkbench review={false} />,
  document.getElementById("root") as HTMLElement,
);
